import { render, staticRenderFns } from "./oneplusxCertifivateAudit.vue?vue&type=template&id=52f4c91a&scoped=true&"
import script from "./oneplusxCertifivateAudit.vue?vue&type=script&lang=js&"
export * from "./oneplusxCertifivateAudit.vue?vue&type=script&lang=js&"
import style0 from "./oneplusxCertifivateAudit.vue?vue&type=style&index=0&id=52f4c91a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f4c91a",
  null
  
)

export default component.exports